var charactersRE = require("./re"),
    dict         = require('./dict');

module.exports = anglicize;

function anglicize(input){

  return input.replace(charactersRE, function(character){
    return dict[character] || character;
  });

}



/*****************
 ** WEBPACK FOOTER
 ** ./~/anglicize/lib/anglicize.js
 ** module id = 571
 ** module chunks = 0
 **/